/*
 * Per-product order note — sticky ATC mirror
 * -----------------------------------------------------------------------------
 * The "order_note" product block (snippets/product-block-order-note.liquid) is a
 * static line-item-property field inside the MAIN product form, so it is already
 * submitted on the main Add to cart and in Quick view. The sticky ATC, however,
 * lives in its own <form>, so a note typed on the page would be lost when adding
 * from the sticky bar. This mirrors the page note into the sticky ATC form as a
 * hidden property input, kept in sync as the shopper types.
 *
 * Quick-view / drawer copies of the block are scoped out — they add through their
 * own form, so they don't (and mustn't) feed the page's sticky ATC.
 */
(function () {
  var STICKY = '#sticky-atc';
  var SCOPE = '.modal, .offcanvas';

  function stickyForm() {
    var s = document.querySelector(STICKY);
    return s ? s.querySelector('form') : null;
  }

  // Note fields that belong to the page itself (not a quick-view/drawer copy).
  function pageNoteFields() {
    return Array.prototype.filter.call(
      document.querySelectorAll('[data-order-note] [data-order-note-field]'),
      function (f) { return !f.closest(SCOPE); }
    );
  }

  function sync() {
    var form = stickyForm();
    if (!form) return;

    var fields = pageNoteFields();
    // Signature of the current note state; skip work (and avoid a mutation loop)
    // when nothing actually changed.
    var sig = fields.map(function (f) { return f.getAttribute('name') + '=' + f.value; }).join('');
    if (form._orderNoteSig === sig) return;
    form._orderNoteSig = sig;

    Array.prototype.forEach.call(form.querySelectorAll('input[data-order-note-synced]'), function (n) { n.remove(); });

    fields.forEach(function (field) {
      var name = field.getAttribute('name');
      if (!name) return;
      var val = field.value;
      if (val == null || val === '') return; // empty -> Shopify would drop it anyway
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = name;
      hidden.value = val;
      hidden.setAttribute('data-order-note-synced', '');
      form.appendChild(hidden);
    });
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-order-note]')) sync();
  });

  // Keep it fresh when the sticky bar mounts or the section re-renders.
  if ('MutationObserver' in window) {
    var p = null;
    new MutationObserver(function () {
      if (p) return;
      p = requestAnimationFrame(function () { p = null; sync(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  ['shown.bs.modal', 'shown.bs.offcanvas'].forEach(function (evt) { document.addEventListener(evt, sync); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
